"use client";
'use strict';

var React = require('react');
var browser = require('@sravni/ab-testing-sdk/lib/browser');

const DEFAULT_VALUE = new browser.AbTestingSdk({ experiments: {}, statistics: '', userData: {} });
const AbTestingContext = React.createContext(DEFAULT_VALUE);

exports.AbTestingContext = AbTestingContext;
exports.DEFAULT_VALUE = DEFAULT_VALUE;
//# sourceMappingURL=Context.js.map
